import initHeader from "./components/headerInit";
import carousel from "./components/carousel";
import historyCarousel from "./components/historyCarousel";
import hover from "./utils/hover";
import scrollAnimations from "./components/scrollAnimations";
import softSlider from "./components/softSlider";

import productsSort from "./components/productsSort";
import stickyNav from "./components/stickyNav";
import * as dialog from "./components/dialog";
import Tabs from "./components/tabs";

import forms from "./components/forms";
import certificatesSlider from "./components/certificatesSlider";
import files from "./components/files";
import certificatesMasonry from "./components/certificatesMasonry";
import copyUri from "./components/copyUri";
import initContacts from "./components/contacts";
import initSearch from "./components/search";
import StickyBlock from "./components/stickyBlock";
import softFeaturesBlock from "./components/softFeaturesBlock";
import counter from "./components/aboutUsCounter";
import softAnimations from "./components/softAnimations";
import scrollToAnchor from "./utils/scrollToAnchor";
import supportInit from "./components/support";
import matchHeightElements from "./components/matchHeight";
import readMore from "./components/seo-text";

const salesTabs = new Tabs('.js-sales-tab-link'),
    stickyProductParams = new StickyBlock(),
    stickyCertificateArrow = new StickyBlock('.js-sticky-arrow', '.js-sticky-arrow-wrapper', 992),
    stickyCertificate = new StickyBlock('.js-sticky-certificate', '.js-sticky-certificate-wrapper', 1250);


$(document).ready(function () {
    $('body').addClass('loaded')
    initHeader();
    carousel('.js-front-products-slider');
    hover('.footer__lang', true);
    hover('.js-hover', false, '.js-hover-parent');
    hover('.js-product-hover', false);
    scrollAnimations();
    productsSort();
    stickyNav('.js-sticky-element', '.js-sticky-start-scroll');
    dialog.initDialog('.js-dialog');
    dialog.initVideoDialog('.js-video-dialog');
    forms();
    files();
    historyCarousel('.js-about-history', 'full');
    certificatesSlider();
    certificatesMasonry();
    salesTabs.init();
    copyUri();

    matchHeightElements();

    initContacts();

    initSearch();
    softSlider();
    stickyProductParams.init();
    stickyCertificate.init();
    stickyCertificateArrow.init();
    softFeaturesBlock()
    counter()
    softAnimations();
    scrollToAnchor();

    supportInit();
    readMore();

});